// Light and dark palettes — ported by value from ebs-platform-web
// (`packages/shared/src/theme/palette.ts`), the design-system source of truth.
// Change a value there first, then mirror it here AND in both blocks of
// `tokens.css` (`palette.test.ts` fails when the two drift).

export type ThemeMode = 'light' | 'dark'

export const lightPalette = {
  text: '#0B1420',
  textSecondary: '#3F4A5A',
  menuText: '#3F4A5A',
  textTertiary: '#5B6675',
  textQuaternary: '#8A95A4',
  textDisabled: '#B5BCC5',
  textOnPrimary: '#FFFFFF',
  spotlight: '#0B1420',
  layout: '#F4F6F8',
  container: '#FFFFFF',
  elevated: '#FFFFFF',
  subtle: '#F8FAFB',
  hover: '#F1F5F9',
  tag: '#EEF2F6',
  track: '#EFF1F4',
  segmentSelected: '#FFFFFF',
  choiceSelected: '#EAEEF2',
  selected: '#EAEEF2',
  selectedHover: '#EEF2F6',
  itemActive: '#F7F9FC',
  itemActiveHover: '#EFF3F8',
  rowHover: '#F7F9FC',
  rowSelected: '#F1F5F9',
  rowSelectedHover: '#EFF3F8',
  sortedColumn: '#F8FAFB',
  border: '#D7DCE2',
  borderSecondary: '#E8ECF1',
  split: '#EAEEF2',
  skeletonFrom: 'rgba(11,20,32,0.04)',
  skeletonTo: 'rgba(11,20,32,0.08)',
  infoBg: '#E0E7FF',
  infoBorder: '#C7D2FE',
  successBg: '#DCFCE7',
  successBorder: '#BBF7D0',
  warningBg: '#FFEDD5',
  warningBorder: '#FED7AA',
  errorBg: '#FEE2E2',
  errorBorder: '#FECACA',
  badgeFill: '#DC2626',
  successText: '#15803D',
  warningText: '#C2410C',
  errorText: '#B91C1C',
  errorTextActive: '#C92E34'
}

type Palette = typeof lightPalette

export const darkPalette: Palette = {
  text: '#ECEEF1',
  textSecondary: '#B6BBC3',
  menuText: '#D4D8DE',
  textTertiary: '#9299A3',
  textQuaternary: '#6F7680',
  textDisabled: '#565C65',
  textOnPrimary: '#0B0D10',
  spotlight: '#30343B',
  layout: '#0F1114',
  container: '#16181C',
  elevated: '#1D2025',
  subtle: '#1A1D21',
  hover: '#23262C',
  tag: '#262A30',
  track: '#0F1114',
  segmentSelected: '#3A3F47',
  choiceSelected: '#3A3F47',
  selected: '#30343B',
  selectedHover: '#2A2E35',
  itemActive: '#23262C',
  itemActiveHover: '#2A2E35',
  rowHover: '#1D2025',
  rowSelected: '#30343B',
  rowSelectedHover: '#2A2E35',
  sortedColumn: '#1D2025',
  border: '#343941',
  borderSecondary: '#272B31',
  split: '#272B31',
  skeletonFrom: 'rgba(255,255,255,0.04)',
  skeletonTo: 'rgba(255,255,255,0.08)',
  infoBg: '#1A2140',
  infoBorder: '#2B3870',
  successBg: '#10281A',
  successBorder: '#1C4A2E',
  warningBg: '#2E1D0E',
  warningBorder: '#5A3714',
  errorBg: '#2E1415',
  errorBorder: '#5C2426',
  badgeFill: '#D32029',
  successText: '#4ADE80',
  warningText: '#FB923C',
  errorText: '#F87171',
  errorTextActive: '#FCA5A5'
}

export const darkBrandPrimary = '#14B8A6'

export const darkSemanticSeed = {
  colorInfo: '#8CA0FF',
  colorSuccess: '#22C55E',
  colorWarning: '#FB923C',
  colorError: '#F87171'
}

export const palettes: Record<ThemeMode, Palette> = {
  light: lightPalette,
  dark: darkPalette
}
